import { ActionButtonVariants } from 'components/action-button';

export default {
  itemNameTextTransform: 'uppercase',
  buttonContainerMarginTop: 'auto',
  modalPadding: '3rem 3.25rem calc(3.5rem + env(safe-area-inset-bottom))',
  changeStoresButtonVariant: ActionButtonVariants.INVERSE,
};
